import React, { useState, useEffect } from 'react';
import { useCurrency } from '@/hooks/useCurrency';
import useBasketStore from '@/context/BasketStore';
import useCountryDetailsStore from '@/context/CountryDetailsStore';
import { motion, AnimatePresence } from 'framer-motion';
import StarRating from '@/components/StarRating';

interface NotificationMessage {
    id: string;
    content: React.ReactNode;
    className?: string;
}

const NotificationBar: React.FC = () => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [amountToFreeDelivery, setAmountToFreeDelivery] = useState<number>(0);
    const { formatPrice } = useCurrency();
    const { basketItems } = useBasketStore();
    const { countryDetails } = useCountryDetailsStore();

    useEffect(() => {
        let price: number = 0;
        basketItems.forEach(item => {
            price += item.price * 100;
        });

        // Get standard shipping rate
        const standardShipping = countryDetails?.shippingRates?.find(rate => rate.name === 'Standard Shipping');
        if (standardShipping?.type === 'threshold' && standardShipping.thresholds) {
            // Find the free shipping threshold
            const freeShippingThreshold = standardShipping.thresholds.find(threshold => threshold.amount === 0);
            if (freeShippingThreshold) {
                setAmountToFreeDelivery(freeShippingThreshold.minAmount)
            }
        }
    }, [basketItems, countryDetails]);

    const messages: NotificationMessage[] = [
        // {
        //     id: 'christmas-delivery',
        //     content: (
        //         <div className="flex w-full items-center gap-2 text-white font-headline">
        //             🎄  Order by Dec 20 for UK Christmas delivery  <a href="/legal/delivery-and-returns#christmas-delivery" className="underline ml-1 text-kibuBlue">Learn more</a>  🎄
        //         </div>
        //     ),
        //     className: "bg-orange-600"
        // },
        {
            id: 'free-shipping',
            content: (
                <div className="flex w-full items-center gap-2 text-white font-headline">
                    🚚  Free shipping on all orders over {formatPrice(amountToFreeDelivery || 0, true)}  🚚
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'made-in-britain',
            content: (
                <div className="flex w-full items-center gap-2 text-white font-headline">
                    🇬🇧  Made in Britain  🇬🇧
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'guarantee',
            content: (
                <div className="flex w-full items-center gap-2 text-white font-headline">
                    30-day money back guarantee
                </div>
            ),
            className: "bg-orange-600"
        },
        // {
        //     id: 'reviews',
        //     content: (
        //         <div className="flex w-full items-center gap-2">
        //             <StarRating rating={5} size="sm" />
        //             <span className="font-headline">5/5 - Loved by kids & parents!</span>
        //         </div>
        //     ),
        //     className: "bg-orange-600"
        // }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentMessageIndex((prevIndex) =>
                prevIndex === messages.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [messages.length]);

    const currentMessage = messages[currentMessageIndex];

    return (
        <div className={`flex fixed h-[28px] md:h-[34px] top-0 left-0 z-30 w-full text-white text-center items-center justify-center text-[14px] font-headline overflow-hidden transition-colors duration-500 ${currentMessage.className}`}>
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.div
                    key={currentMessage.id}
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -30, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="w-full whitespace-nowrap px-4 flex items-center justify-center"
                >
                    <div className="inline-flex items-center justify-center gap-2">
                        {currentMessage.content}
                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default NotificationBar; 